(function () {
  function initDirectProductZoom() {
    const galleryImages = document.querySelectorAll(
      '.js-media-list .product__media-item img, .js-media-list-mobile .product__media-item img'
    );

    galleryImages.forEach((image) => {
      if (image.dataset.directZoomReady === 'true') return;
      image.dataset.directZoomReady = 'true';

      const slide = image.closest('.product__media-item, .swiper-slide');

      const media =
        image.closest('.product__media') ||
        image.closest('.product__modal-opener') ||
        image.closest('.media');

      const zoomArea =
        image.closest('.product__modal-opener') ||
        image.closest('.product__media') ||
        image.closest('.media') ||
        slide;

      if (!slide || !media || !zoomArea) return;

      slide.classList.add('mp-direct-zoom-slide');
      media.classList.add('mp-direct-zoom-media');
      zoomArea.classList.add('mp-direct-zoom-area');
      image.classList.add('mp-direct-zoom-image');

      let zoomActive = false;
      let touchTimer = null;
      let startX = 0;
      let startY = 0;

      function getPoint(event) {
        return event.touches ? event.touches[0] : event;
      }

      function updateZoomPosition(event) {
        const point = getPoint(event);
        const rect = zoomArea.getBoundingClientRect();

        const x = ((point.clientX - rect.left) / rect.width) * 100;
        const y = ((point.clientY - rect.top) / rect.height) * 100;

        image.style.transformOrigin = `${Math.max(0, Math.min(100, x))}% ${Math.max(0, Math.min(100, y))}%`;
      }

      function enableZoom(event) {
        zoomActive = true;
        media.classList.add('is-direct-zooming');
        zoomArea.classList.add('is-direct-zooming');
        updateZoomPosition(event);

        const swiper = slide.closest('.swiper')?.swiper;
        if (swiper) swiper.allowTouchMove = false;
      }

      function disableZoom() {
        zoomActive = false;
        media.classList.remove('is-direct-zooming');
        zoomArea.classList.remove('is-direct-zooming');
        image.style.transformOrigin = 'center center';
        image.style.transform = '';

        const swiper = slide.closest('.swiper')?.swiper;
        if (swiper) swiper.allowTouchMove = true;

        if (touchTimer) {
          clearTimeout(touchTimer);
          touchTimer = null;
        }
      }

      // Desktop : hover = zoom direct dans l’image
zoomArea.addEventListener('mouseover', function (event) {
  if (window.innerWidth < 750) return;

  image.style.transform = 'scale(2.15)';
  enableZoom(event);
});

zoomArea.addEventListener('mousemove', function (event) {
  if (window.innerWidth < 750) return;
  if (!zoomActive) return;

  image.style.transform = 'scale(2.15)';
  updateZoomPosition(event);
});

zoomArea.addEventListener('mouseout', function (event) {
  if (window.innerWidth < 750) return;

  if (!zoomArea.contains(event.relatedTarget)) {
    image.style.transform = '';
    disableZoom();
  }
});

      // Mobile : touch quasi immédiat = zoom
      zoomArea.addEventListener(
        'touchstart',
        function (event) {
          if (window.innerWidth >= 750) return;
          if (!event.touches || event.touches.length !== 1) return;

          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;

          touchTimer = setTimeout(function () {
            enableZoom(event);
          }, 40);
        },
        { passive: true }
      );

      zoomArea.addEventListener(
        'touchmove',
        function (event) {
          if (window.innerWidth >= 750) return;
          if (!event.touches || event.touches.length !== 1) return;

          const moveX = Math.abs(event.touches[0].clientX - startX);
          const moveY = Math.abs(event.touches[0].clientY - startY);

          if (!zoomActive && (moveX > 10 || moveY > 10)) {
            if (touchTimer) {
              clearTimeout(touchTimer);
              touchTimer = null;
            }
            return;
          }

          if (zoomActive) {
            event.preventDefault();
            updateZoomPosition(event);
          }
        },
        { passive: false }
      );

      zoomArea.addEventListener('touchend', disableZoom);
      zoomArea.addEventListener('touchcancel', disableZoom);
    });
  }

  function disableNativeProductModal() {
    const modalOpeners = document.querySelectorAll(
      '.js-media-list .product__modal-opener, .js-media-list-mobile .product__modal-opener, .js-media-list .product__media-toggle, .js-media-list-mobile .product__media-toggle'
    );

    modalOpeners.forEach((element) => {
      if (element.dataset.modalDisabled === 'true') return;
      element.dataset.modalDisabled = 'true';

      element.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return false;
        },
        true
      );
    });
  }

  function init() {
    initDirectProductZoom();
    disableNativeProductModal();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  setTimeout(init, 500);
  setTimeout(init, 1200);
  setTimeout(init, 2000);
})();